module.exports = __webpack_public_path__ + "img/firmas_banner.68de7a0.svg";